import { Injectable } from "@angular/core";
//import 'rxjs/add/operator/toPromise';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { auth } from 'firebase/app';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';
import { rejects } from "assert";
import { WindowService } from "./window.service";



@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  uid;
  windowRef: any;
//authState

  constructor(
    public auth: AngularFireAuth,
    private db: AngularFirestore,
    public route: Router,
    private win: WindowService
  ){ }

  checkIfPeopleLoggedIn(){
    return new Promise<any>((resolve, reject) =>{
      this.auth.onAuthStateChanged(user => {
        if (user){
          resolve(user.email)
        }
      },err => reject(err))
    })
  }

  getPeopleSignInUid(){
    return new Promise<any>((resolve, reject) =>{
      this.auth.onAuthStateChanged(user => {
        if (user){                 
          resolve(user)        }
      },err => reject(err))
    })
  }

  getPeopleSignUpUid(){
    return new Promise<any>((resolve, reject) =>{
      this.auth.currentUser
      .then(res=>{
        resolve(res)
        //return res.uid        
      }, err => reject(err))
    })
  }

  addPeopleWithEmailAndPassword(value){
    return new Promise<any>((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(value.email, value.password)
      .then(res => {
        resolve(res);
      }, err => reject(err))
    })
  }

  loginWithGoogle(){
    return new Promise<any>((resolve, reject) => {
      this.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider())      
      .then(res => {
        res.additionalUserInfo.isNewUser
        res.additionalUserInfo.providerId
        res.user.uid
        res.user.displayName
        res.user.email
        res.user.photoURL
        resolve(res);
      }, err => reject(err))
    })
  }

  loginWithFacebook(){
    return new Promise<any>((resolve, reject) => {
      this.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider())  
      .then(res => {
        res.user.displayName
        res.user.email
        resolve(res);
      }, err => reject(err))
    })
  }

  loginWithPhone(){
    return new Promise<any>((resolve, reject) => {
      this.auth.signInWithPopup(new firebase.auth.PhoneAuthProvider())  
      .then(res => {
        res.user.displayName
        res.user.email
        resolve(res);        
      }, err => reject(err))
    })

    
  }
 
  doLogin(value){
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(value.email, value.password)
      .then(res => {
        resolve(res);
      }, err => reject(err))
    })
  }
 
  doLogout(){
    return new Promise((resolve, reject) => {
    
      if(firebase.auth().currentUser){
      this.auth.signOut()
      .then(res => {
        this.route.navigate(['people/login'])
      })
      //  resolve();
    }
    else{
      reject();
    }
    
    });
  }
  
  deletePeople(){
    this.auth.currentUser
    .then( res => {
      res.delete();
    })
  }

  doFacebookLogin(){
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.FacebookAuthProvider();
      this.auth
      .signInWithPopup(provider)
      .then(res => {
        resolve(res);
      }, err => {
        reject(err);
      })
    })
  }

  doTwitterLogin(){
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.TwitterAuthProvider();
      this.auth
      .signInWithPopup(provider)
      .then(res => {
        resolve(res);
      }, err => {
        reject(err);
      })
    })
  }

  doGoogleLogin(){
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.auth.signInWithPopup(provider)
      .then(res => {
        res.credential.providerId
        resolve(res);
      }, err => {
        reject(err);
      })
    })
  }

  GoogleAuth() {
    return this.AuthLogin(new auth.GoogleAuthProvider());
  }  
  // Auth logic to run auth providers
  AuthLogin(provider) {
    return this.auth.signInWithPopup(provider)
    .then((result) => {
    }).catch((error) => {
    })
  }

}